import get from 'lodash/get';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import CenterWrapper from '~/components/CenterWrapper/CenterWrapper';
import TableActionBar from "~/ui/TableActionBar/TableActionBar";
import SearchFilter from '~/ui/TableActionBar/SearchFilter';

import NavigatableModelTable from "~/ui/ModelResultTable/NavigatableModelTable"
import {
    getDataActionPermissions,
    getModelName, getModelTooltip,
    getParentId, getModelTitle,
    getSingleTitle, getTooltipsActive,
    presentError, getCreatePath
} from "~/stateGetter";
import {connect} from "~/redux/connect";
import MessageList from "~/ui/MessageList/MessageList";
import {pushClose, pushCurrentModelPath} from "~/actions/navigation_actions";
import css from './css.css';
import LoadingContainer from "~/ui/Loading/LoadingContainer";
import { Divider, HStack, VFlexPropagate } from "~/native-ui";
import {FilterList} from '~/ui/Filters';




export class TabularViewComponent extends Component {
    static propTypes = {
        modelTitle: PropTypes.string,
        modelId: PropTypes.string.isRequired
    };

    filterMessages = (messages) => {
        let filteredMessages = messages.filter(({source}) => {
            return ['results', 'customActionResult'].indexOf(source) > -1
        });

        return filteredMessages;
    };

    render() {
        let { modelId, resultsError } = this.props;

        return (
            <VFlexPropagate height="100%">
                <TableActionBar
                    modelId={modelId}
                    title={this.props.modelTitle}
                    addText={this.props.singleTitle}
                    onAdd={this.props.addEntry}
                    parentModelId={this.props.parentModelId}
                    onClose={this.props.pushClose || (() => {})}
                    canCreate={this.props.canCreate}
                    createTooltip={this.props.createTooltip}
                />
                <HStack w="100%" py="3" px="3" space="2" alignItems="center">
                    <SearchFilter modelId={this.props.modelId} />
                    <FilterList modelId={this.props.modelId} />
                </HStack>
                <Divider />
                <CenterWrapper full px="3">
                    <MessageList modelId={modelId} filterMessages={this.filterMessages} className={css.messageList} />
                    {!resultsError && <NavigatableModelTable autoHeight colorBlend modelId={modelId} /> }
                </CenterWrapper>
            </VFlexPropagate>
        );
    }
}

const TabularModelView = (props) => {
    const ConnectedComponent = connect((state, {modelId}) => {
            return {
                singleTitle: getSingleTitle(state, modelId),
                modelTitle: getModelTitle(state, modelId),
                modelName: getModelName(state, modelId),
                resultsError: get(presentError(state, modelId, 'results'), 'message'),
                parentModelId: getParentId(state, modelId),
                canCreate: getDataActionPermissions(state, modelId).create,
                createTooltip: getModelTooltip(state, modelId, 'create'),
                tooltipsActive: getTooltipsActive(state),
                createPath: getCreatePath(state, modelId)
            }
        },
        (dispatch, { modelId }) => {
            return {
                push: (...args) => dispatch(pushCurrentModelPath(...args)),
                pushClose: () => dispatch(pushClose())
            }
        },
        ({createPath, ...props}, { push, ...dispatchProps }, ownProps) => {
            let { modelName, ...otherProps} = props;

            return {
                ...ownProps, ...otherProps, ...dispatchProps,
                addEntry: () => push({
                    query: createPath.params,
                    pathname: `/${modelName}${createPath.path}`
                }),
            }
        }
    )(TabularViewComponent);

    return (
        <LoadingContainer ready={['resultsReady']} modelId={props.modelId}>
            <ConnectedComponent {...props} />
        </LoadingContainer>
    );
};

export default TabularModelView;